import { useCallback, useEffect } from 'react';
import { useSafeNavigation, useSafeRouteParams } from '@sg/garnish';

import { LOYALTY_HOME_SCREEN } from '../../../../constants';
import { useTrackLoyaltyOnboardingModalNavigation } from '../../../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A custom hook that manages the referrer parameter for the Loyalty Home screen.
 */
export const useLoyaltyHomeScreenReferrer = () => {
  const params = useSafeRouteParams<LoyaltyHomeParams>() ?? {};
  const navigation = useSafeNavigation();

  const isNavigatedFromOnboarding =
    params.referrer === LOYALTY_HOME_SCREEN.REFERRERS.ONBOARDING;

  // ─── Helpers ─────────────────────────────────────────────────────────

  const removeReferrerParam = useCallback(() => {
    navigation?.setParams({ referrer: undefined });
  }, [navigation]);

  const trackLoyaltyOnboardingModalNavigation =
    useTrackLoyaltyOnboardingModalNavigation({
      hasNavigated: isNavigatedFromOnboarding,
      onTrack: removeReferrerParam,
    });

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(trackLoyaltyOnboardingModalNavigation);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyHomeParams = {
  referrer?: string;
};
